import React from 'react';
import { buildClassName } from 'utils/build-class-name';
import NextImage from 'next/image';
import styles from './style.module.scss';

export default function AboutUsHero() {
  return (
    <div className={styles.hero}>
      <div className={styles.container}>
        <div className={buildClassName(styles['brush-stroke'], styles['brush-stroke-1'])}>
          <NextImage
            key="b-1"
            fill={true}
            src="/next/assets/images/brush-stroke-1.png"
            alt="Zoocasa brush stroke"
            priority={true}
          />
        </div>
        <div className={buildClassName(styles['brush-stroke'], styles['brush-stroke-2'])}>
          <NextImage
            key="b-1"
            fill={true}
            src="/next/assets/images/brush-stroke-2.png"
            alt="Zoocasa brush stroke"
            priority={true}
          />
        </div>
        <div className={styles.content}>
          <h1>About Us</h1>
          <NextImage className={styles['hero-image']} src="/next/assets/images/about/about-us-hero.png" alt="Zoocasa - About Us" width={500} height={300} />
        </div>
      </div>
    </div>
  );
}
